export const MODES = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
};
